import { Component, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import cloud from 'd3-cloud';
import * as d3 from 'd3';

class Row extends Component
{
    render()
    {
        const { className, children, ...rest } = this.props;

        return (
            <div className = {className === undefined ? 'row' : `row ${className}`} {...rest}>
                {children}
            </div>
        )
    }
}

class Col extends Component
{
    render()
    {
        const { className, children, ...rest } = this.props;

        return (
            <div className = {className === undefined ? 'column' : `column ${className}`} {...rest}>
                {children}
            </div>
        )
    }
}

class GRID extends Component
{
    render()
    {
        const { className, children, ...rest } = this.props;

        return (
            <div className = {className === undefined ? 'grid' : `grid ${className}`} {...rest}>
                {children}
            </div>
        )
    }
}

function RefreshOnNavigate()
{
    const location = useLocation();

    function refresh()
    {
        document.documentElement.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

        document.querySelector('#nav .float').style.display = 'none';

        document.querySelectorAll('img').forEach(x => x.setAttribute('draggable', false));

        const titleKey = location.pathname.split('/')[1];

        const title =
        {
            '': 'Q2Lens',
            'solutions': 'Solutions | Q2Lens',
            'usecase': 'Use Cases | Q2Lens',
            'sample': 'Sample Reports | Q2Lens',
            'perspective': 'Perspectives | Q2Lens',
            'pricing': 'Pricing | Q2Lens',
            'contact': 'Contact Us | Q2Lens'
        };

        document.title = title[titleKey];
    };

    useEffect(refresh, [location]);

    return null;
}

class WordCloud extends Component
{
    constructor(props)
    {
        super(props);
        this.ref = null;
    }

    componentDidMount()
    {
        const { words, size, font, fontSizeRange, rotations, spiral, padding } = this.props;

        const counts = words.map(w => w.count);

        const fontScale = d3.scaleSqrt().domain([Math.min(...counts), Math.max(...counts)]).range(fontSizeRange);

        cloud()
        .size(size)
        .words(words.map(({text, count}) => ({text, size: fontScale(count)})))
        .padding(padding)
        .rotate(() => rotations[Math.floor(Math.random() * rotations.length)])
        .fontSize(d => d.size)
        .spiral(spiral)
        .on('end', (newWords) =>
        {
            d3.select(this.ref).selectAll('*').remove()

            d3.select(this.ref)
            .attr('width', size[0])
            .attr('height', size[1])
            .append('g')
            .attr('transform', `translate(${size[0] / 2}, ${size[1] / 2})`)
            .selectAll('text')
            .data(newWords)
            .enter()
            .append('text')
            .style('font-family', font)
            .style('font-size', d => `${d.size}px`)
            .style('fill', () => d3.schemeCategory10[Math.floor(Math.random() * 10)])
            .attr('text-anchor', 'middle')
            .attr('transform', d => `translate(${d.x},${d.y})rotate(${d.rotate})`)
            .text(d => d.text);
        })
        .start();
    }

    render()
    {
        const { words, size, font, fontSizeRange, rotations, spiral, padding, children, ...rest } = this.props;

        return (
            <svg ref={element => this.ref = element} {...rest}>
                {children}
            </svg>
        )
    }
}

export { Row, Col, GRID, RefreshOnNavigate, WordCloud }